/* assets/ac-cart-options.js
   Tidies the Cloudlift option rows on cart lines (drawer .ac-cd-prop, cart page .ac-ct-prop),
   2026-09-24. Most phone case configs store MagSafe as two answers:
     Case Type: Tough (Recommended) | $2.99
     MagSafe Upgrade: Yes, Please! | $4.99
   The product page shows one "Tough MagSafe" card, so the cart shows one line too:
     Case Type: Tough MagSafe | $7.98
   The MagSafe row is hidden by CSS (artisticases-cart-drawer.css) and "(Recommended)" is
   dropped from the values. Since the same day, snippets/ac-cart-rewrite.liquid also stores the
   tidy values on NEW cart lines (so checkout, order and emails match); this file still covers
   lines added before that, and fixes the price Cloudlift prints next to "Tough MagSafe".

   Cloudlift appends the " | $price" to each value after the theme renders the row and may
   re-process rows, so the original <dd> is left alone (hidden with .ac-prop-orig) and the tidy
   text goes into a sibling <dd class="ac-prop-shown">. Writes only when the text differs, so
   the observer below settles after one pass. */
(function () {
  var ROW = '.ac-cd-prop, .ac-ct-prop';

  function labelOf(row) {
    var dt = row.querySelector('dt');
    return dt ? dt.textContent.replace(/:\s*$/, '').trim() : '';
  }
  function origDd(row) {
    return row.querySelector('dd:not(.ac-prop-shown)');
  }
  function split(text) {
    var i = text.lastIndexOf(' | ');
    return i < 0 ? { value: text.trim(), price: '' } : { value: text.slice(0, i).trim(), price: text.slice(i + 3).trim() };
  }
  function clean(value) {
    return value.replace(/\s*\(recommended\)\s*/i, ' ').replace(/\s+-\s+MagSafe$/i, ' MagSafe').replace(/\s+/g, ' ').trim();
  }
  /* "$2.99" + "$4.99" -> "$7.98", keeping the first price's symbol and decimal mark. */
  function addPrices(a, b) {
    var re = /\d[\d.,\s]*/;
    var ma = a.match(re), mb = b.match(re);
    if (!ma || !mb) return '';
    var decimals = /[.,]\d{2}\s*$/.test(ma[0]) ? 2 : 0;
    var mark = decimals ? ma[0].trim().slice(-3, -2) : '.';
    var toNum = function (s) {
      var digits = s.replace(/\D/g, '');
      return parseInt(digits, 10) / Math.pow(10, /[.,]\d{2}\s*$/.test(s) ? 2 : 0);
    };
    var sum = (toNum(ma[0]) + toNum(mb[0])).toFixed(decimals).replace('.', mark);
    return a.replace(ma[0].trim(), sum);
  }
  /* The line's _cl_options_price (cents, shop currency) formatted like Cloudlift's own label. */
  function lineSurcharge(row, sample) {
    var li = row.closest('[data-ac-cl-price]');
    var cents = li ? parseInt(li.getAttribute('data-ac-cl-price'), 10) : NaN;
    if (!sample || isNaN(cents)) return '';
    var cur = window.Shopify && window.Shopify.currency;
    var rate = cur && cur.rate && li.getAttribute('data-ac-cl-currency') !== cur.active ? parseFloat(cur.rate) : 1;
    var m = sample.match(/\d[\d.,\s]*/);
    if (!m) return '';
    var decimals = /[.,]\d{2}\s*$/.test(m[0]) ? 2 : 0;
    var mark = decimals ? m[0].trim().slice(-3, -2) : '.';
    return sample.replace(m[0].trim(), (cents / 100 * rate).toFixed(decimals).replace('.', mark));
  }
  function show(row, text) {
    var orig = origDd(row);
    if (!orig) return;
    var shown = row.querySelector('dd.ac-prop-shown');
    if (text === orig.textContent.trim()) {
      if (shown) shown.remove();
      if (orig.classList.contains('ac-prop-orig')) orig.classList.remove('ac-prop-orig');
      return;
    }
    if (!shown) {
      shown = document.createElement('dd');
      shown.className = 'ac-prop-shown';
      orig.insertAdjacentElement('afterend', shown);
    }
    if (shown.textContent !== text) shown.textContent = text;
    if (!orig.classList.contains('ac-prop-orig')) orig.classList.add('ac-prop-orig');
  }

  function tidyList(list) {
    var rows = Array.prototype.filter.call(list.children, function (el) { return el.matches(ROW); });
    var byLabel = {};
    rows.forEach(function (row) { byLabel[labelOf(row).toLowerCase()] = row; });
    var caseRow = byLabel['case type'];
    var msRow = byLabel['magsafe upgrade'] || byLabel['magesafe upgrade'];
    if (msRow && !msRow.classList.contains('ac-prop-hidden')) msRow.classList.add('ac-prop-hidden');

    if (caseRow && origDd(caseRow)) {
      var c = split(origDd(caseRow).textContent);
      var ms = msRow && origDd(msRow) ? split(origDd(msRow).textContent) : null;
      var text;
      if (ms && /yes/i.test(ms.value)) {
        var total = c.price && ms.price ? addPrices(c.price, ms.price) : (c.price || ms.price);
        text = 'Tough MagSafe' + (total ? ' | ' + total : '');
      } else if (/^tough\s*-?\s*magsafe$/i.test(clean(c.value))) {
        /* Lines added since the add-to-cart rewrite (snippets/ac-cart-rewrite.liquid) carry
           "Tough MagSafe" in one property; Cloudlift labels it with Tough's own price, so use
           the line's whole Cloudlift surcharge (printed on the <li> by the cart templates;
           Case Type is the only priced phone case option). */
        text = 'Tough MagSafe' + (lineSurcharge(caseRow, c.price) ? ' | ' + lineSurcharge(caseRow, c.price) : (c.price ? ' | ' + c.price : ''));
      } else {
        text = clean(c.value) + (c.price ? ' | ' + c.price : '');
      }
      show(caseRow, text);
    }
    var finishRow = byLabel['print finish'];
    if (finishRow && origDd(finishRow)) {
      var f = split(origDd(finishRow).textContent);
      show(finishRow, clean(f.value) + (f.price ? ' | ' + f.price : ''));
    }
  }

  function tidyAll() {
    var lists = [];
    document.querySelectorAll(ROW).forEach(function (row) {
      if (row.parentElement && lists.indexOf(row.parentElement) < 0) lists.push(row.parentElement);
    });
    lists.forEach(tidyList);
  }

  var timer = null;
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(tidyAll, 40);
  }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  schedule();
})();
